import { Component, OnInit, ViewChild } from '@angular/core';
import { GridViewComponent } from '../../../../shared/components/grid-view/grid-view.component';
import { Listing } from '../../../../shared/models/listing.model';
import { GlobalServices } from '../../../../shared/services/global.service';
import { Languages } from '../../../../shared/models/enums.model';
import { SupplierBidSubsriptionService } from 'src/app/shared/services/supplierBidSubsription.service';
import { TranslateService } from '@ngx-translate/core';
import { AppConfig } from 'src/app/shared/services/app.config';
import { DatePipe } from '@angular/common';

@Component({
  selector: 'app-bid-supplier-subscription-list',
  templateUrl: './bid-supplier-subscription-list.component.html',
  styleUrls: ['./bid-supplier-subscription-list.component.css']
})
export class BidSupplierSubscriptionListComponent implements OnInit {
  private collection: Listing;
  @ViewChild('BidSupplierSubscriptionList',{static: false}) gridView: GridViewComponent;
  pageSize=10;
  creationDateFrom: string = "";
  creationDateTo: string = "";
  dateFromFormatted: string = "";
  dateToFormatted: string = "";
  private itemsMenu: MenuItem[] = [];
  hideExportButton:boolean;
  showFromDateGreaterThanTodayDateMessage: Boolean
  showFromDateGreaterThanToDateMessage: Boolean
  constructor(private global: GlobalServices,
    private supplierBidSubscriptionSrv:SupplierBidSubsriptionService,
  private translate:TranslateService,
  public datepipe: DatePipe) { }


  ngOnInit() {
    this.loadData();

  }
  loadCollectionCompleted() {

    this.gridView.loadGrid(this.collection,this.collection == null ? 0 : this.collection.TotalNumber, this.pageSize,
                          "SupplierBidSubscription/GetSupplierBidSubscriptionPaged?pageIndex={PAGEINDEX}&pageSize=" + this.pageSize +
                          "&language=" + (this.global.getLanguage() == Languages.Arabic ? "Ar" : "En") +
      "&creationDateFrom=" +this.dateFromFormatted + "&creationDateTo=" + this.dateToFormatted,

                          "SHARED.REPORTS.BIDSUPPLIERSUBSCRIPTION_OBJECT", this.itemsMenu, "", "", "");
    this.global.isLoaderEnabled = false;
  }
  ExportExcel() {
    this.translate.get('SHARED.REPORTS.BIDSUPPLIERSUBSCRIPTION_OBJECT').subscribe((response: string) => {
      let ExportExcelUrl = AppConfig.settings.apiServer.apiUrl +
      "SupplierBidSubscription/ExportBidSubscriptionExcel?bidSupplierObject=" + JSON.stringify(response) +
      "&language=Ar&from=" + this.dateFromFormatted + "&to=" + this.dateToFormatted ;

      window.open(ExportExcelUrl, '_self');
    });
  }
  isFromDateGreaterThanToDate(): Boolean {
    var isFromDateGreaterThanToDate = false;
    if (this.creationDateTo != "") {
      isFromDateGreaterThanToDate = this.creationDateFrom > this.creationDateTo;
    }
    return isFromDateGreaterThanToDate;
  }
  isFromDateGreaterThanTodayDate(): Boolean {

    var isFromDateGreaterThanTodayDate = false;
    var today = new Date();
    var todayDate = this.datepipe.transform(today, 'MM/dd/yyyy');
    var selectedCreationDateFrom = this.datepipe.transform(this.creationDateFrom, 'MM/dd/yyyy');
    isFromDateGreaterThanTodayDate = selectedCreationDateFrom > todayDate;
    return isFromDateGreaterThanTodayDate;
  }
  resetData(){
    this.creationDateFrom = "";
    this.creationDateTo = "";
    this.dateFromFormatted = "";
    this.dateToFormatted = "";
    this.hideExportButton = false;
    this.showFromDateGreaterThanTodayDateMessage=false;
    this.showFromDateGreaterThanToDateMessage = false;
    this.loadData();

  }
  loadData(){
    if(this.isFromDateGreaterThanTodayDate()){
      this.showFromDateGreaterThanTodayDateMessage=true;
      return;
    }
    if (this.isFromDateGreaterThanToDate()) {
      this.showFromDateGreaterThanToDateMessage = true;
      return;
    }
    this.showFromDateGreaterThanTodayDateMessage=false;
    this.showFromDateGreaterThanToDateMessage = false;
    this.creationDateFrom = this.creationDateFrom == null ? "" : this.creationDateFrom;
    this.creationDateTo = this.creationDateTo == null ? "" : this.creationDateTo;

      this.global.isLoaderEnabled = true;
      this.dateFromFormatted = this.creationDateFrom == "" ? "" : this.datepipe.transform(this.creationDateFrom, 'MM/dd/yyyy');
      this.dateToFormatted = this.creationDateTo == "" ? "" : this.datepipe.transform(this.creationDateTo, 'MM/dd/yyyy');
    this.supplierBidSubscriptionSrv.GetSupplierBidSubscriptionPaged( 0, this.pageSize,this.dateFromFormatted, this.dateToFormatted).subscribe(

        d => {

          this.collection = d.Data;
          this.hideExportButton = this.collection.Collection.length >0 ? false : true;
        },
        () => console.log("Something went wrong!!"),
        () => this.loadCollectionCompleted()

      );
  }

}

export class MenuItem {
  Title :string;
  TitleAr :string;
};
